

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { uploadFileUrl, deleteFile } from '@/api/upload'
import { ElUploadInternalFileDetail } from '@/typings/files'

@Component({
  name: 'FileUpload'
})
export default class extends Vue {
  @Prop({ required: true }) params!: Object // 文件附加参数

  private fileList = []
  private uploadFileUrl = uploadFileUrl

  beforeFileUpload(file: ElUploadInternalFileDetail) {
    console.log(file)
  }
  handleFileSuccess(res: any, file: ElUploadInternalFileDetail) {
    console.log(res)
    if (res.status.code === 0) {
      this['$message'].success('文件上传成功')
      // this.params.filePath = res.data.path
      // this.version = res.data.version
      // this.versionCode = res.data.versionCode
      // this.bundleId = res.data.bundleId
      // this.md5 = res.data.md5
      // this.size = res.data.size
      // this.ext = res.data.ext
    }
  }
  // eslint-disable-next-line handle-callback-err
  handleFileError(err:any, file: ElUploadInternalFileDetail) {
    console.log(Object.getOwnPropertyDescriptors(err))
    if (err && err.status === 404) {
      this['$message'].error('上传地址错误!')
    } else {
      this['$message'].error('文件类型不支持，IOS支持ipa')
    }
  }
  handleExceed() {
    this['$message'].warning('最多只能上传一个文件!')
  }
  handleRemove(file: ElUploadInternalFileDetail) {
    console.log(file)
    // let path: string = file.response.data.path
    // this.params.filePath = ''
    // let res: any = await deleteFile({
    //   path: path,
    //   id: this.params.id
    // })
    // console.log(res)
    // if (res.status.code === 0) {
    //   this['$message'].success('文件删除成功')
    // } else {
    //   this['$message'].error('文件删除失败')
    // }
  }
}
